/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An 80 kg, 180 cm, 30-year-old man has a BMR of ~1780 kcal.`)
};

const es_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hombre de 80 kg, 180 cm y 30 años tiene una TMB de ~1780 kcal.`)
};

const de_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein 80 kg schwerer, 180 cm großer, 30-jähriger Mann hat einen BMR von ~1780 kcal.`)
};

const nl_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een man van 80 kg, 180 cm en 30 jaar heeft een BMR van ~1780 kcal.`)
};

const fr_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un homme de 80 kg, 180 cm, 30 ans a un BMR d'environ 1780 kcal.`)
};

const it_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un uomo di 80 kg, 180 cm e 30 anni ha un BMR di circa 1780 kcal.`)
};

const pt_br2_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um homem de 80 kg, 180 cm e 30 anos tem uma TMB de ~1780 kcal.`)
};

const pt_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um homem de 80 kg, 180 cm e 30 anos tem uma TMB de ~1780 kcal.`)
};

const ja_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体重80kg、身長180cm、30歳の男性の基礎代謝は約1780kcalです。`)
};

const zh_bmr_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一位体重 80 千克、身高 180 厘米、30 岁的男性，基础代谢率约为 1780 千卡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_ex1", locale)
	if (locale === "en") return en_bmr_ex1(inputs)
	if (locale === "es") return es_bmr_ex1(inputs)
	if (locale === "de") return de_bmr_ex1(inputs)
	if (locale === "nl") return nl_bmr_ex1(inputs)
	if (locale === "fr") return fr_bmr_ex1(inputs)
	if (locale === "it") return it_bmr_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_ex1(inputs)
	if (locale === "pt") return pt_bmr_ex1(inputs)
	if (locale === "ja") return ja_bmr_ex1(inputs)
	return zh_bmr_ex1(inputs)
};